import React from "react";
import { useSelector } from "react-redux";
import { MedicacionCard } from "../UI/MedicacionCard";
import { MedicacionDetalleTipoForm } from "./MedicacionDetalleTipoForm";
import { MedicacionDetalleSolicitudInformation } from "./MedicacionDetalleSolicitudInformation";

export const MedicacionDetalleSolicitud = (props) => {
  const { showForm, solicitudSeleccionada = {}} = useSelector(
    (state) => state.empadronamiento
  );

  let idTipoEmpadronamiento;

  if (solicitudSeleccionada != null) {
    idTipoEmpadronamiento = solicitudSeleccionada?.idTipoEmpadronamiento;
  }

  return (
    <MedicacionCard width={"55%"}>
      {showForm ? (
        <MedicacionDetalleTipoForm 
        idTipoEmpadronamiento={idTipoEmpadronamiento}
        fromBandeja = {props.fromBandeja}
        />
      ) : (
        <MedicacionDetalleSolicitudInformation
        idTipoEmpadronamiento={idTipoEmpadronamiento}
        />
      )}
    </MedicacionCard>
  );
};
